define([
	'require',
	'jquery',
	'domReady'
], function(require, $, domReady){

	/**
	*
	*	Handlebars Module Loading Utility
	*
	*/

	var DEBUG = false;

	var HandleBarsLoader = function (moduleDef) {

		var self = this;

		self.moduleDef = moduleDef;
		self.currentPageType = $('body').data('page-type');

		return self.loadHandleBarsModule()
			.done(function(){
				self.initLoadedModule();
			})
			.fail(function(){
				if ( DEBUG ) console.warn('Module Load Failed');
			});

	};

	HandleBarsLoader.prototype = {

		isValidHandleBarsModule : function () {

			if ( DEBUG ) console.log('isValidHandleBarsModule');

			if ( !this.moduleDef.hasOwnProperty('template') ){
				if ( DEBUG ) console.warn('Module Definition Error : --- template property not defined ---');
				return false;
			}

			if ( !this.moduleDef.hasOwnProperty('loadParameters') ){
				if ( DEBUG ) console.warn('Module Definition Error : --- loadParameters property not defined ---');
				return false;
			}

			if ( !this.moduleDef.loadParameters.hasOwnProperty('pluginFN') ){
				if ( DEBUG ) console.warn('Module Definition Error : --- pluginFN property not defined ---');
				return false;
			}

			if ( !this.moduleDef.loadParameters.hasOwnProperty('requireModule') ){
				if ( DEBUG ) console.warn('Module Definition Error : --- requireModule property not defined ---');
				return false;
			}

			if ( this.moduleDef.loadParameters.hasOwnProperty('pageType') ){
				if ( this.moduleDef.loadParameters.pageType.replace(/ /g,'').split(',').indexOf(this.currentPageType) === -1 ){
					if ( DEBUG ) console.warn('Module Definition Error : --- pageType is not a match ---');
					return false;
				}
			}

			if ( !this.moduleDef.loadParameters.hasOwnProperty('target') || $( this.moduleDef.loadParameters.target ).length === 0 ){
				if ( DEBUG ) console.warn('Module Definition Error : --- target property not defined or target element not present ---');
				return false;
			}

			return true;
		},

		loadHandleBarsModule : function () {

			if ( DEBUG ) console.log('loadHandleBarsModule');

			var $moduleDeferred = $.Deferred();

			if ( !this.isValidHandleBarsModule() ){
				$moduleDeferred.reject();
				return $moduleDeferred.promise();
			}

			require([ this.moduleDef.loadParameters.requireModule ], function(){

				$moduleDeferred.resolve();

			});

			return $moduleDeferred.promise();

		},

		initLoadedModule : function () {

			if ( DEBUG ) console.log('initLoadedModule');

			if ( typeof $.fn[this.moduleDef.loadParameters.pluginFN] !== 'undefined' ) {

                $( this.moduleDef.loadParameters.target )[this.moduleDef.loadParameters.pluginFN]( this.moduleDef );

            }

		}

	};

	// expose api for on demand loading of modules
	window.main = window.main || {};
	window.main.handleBarsModulesInit = window.main.handleBarsModulesInit || function(module) {
		return new HandleBarsLoader(module);
	};

	var loadedModules = {};

	// module auto loader factory for WC_CONFIG
	if (typeof WCS_CONFIG !== 'undefined' && WCS_CONFIG.HandleBarsModules !== 'undefined' ) {

		for ( var HandleBarsModule in WCS_CONFIG.HandleBarsModules ) {

			if ( WCS_CONFIG.HandleBarsModules.hasOwnProperty(HandleBarsModule) ){
				loadedModules[HandleBarsModule] = new HandleBarsLoader( WCS_CONFIG.HandleBarsModules[HandleBarsModule] );
			}

		}

	}

	return HandleBarsLoader;
});